// extracted by mini-css-extract-plugin
export default {"item":"Item_item__BpH8j","itemImage":"Item_itemImage__oP+T+"};